import { render, staticRenderFns } from "./AddBlock.vue?vue&type=template&id=e2d5a2dc&"
import script from "./AddBlock.vue?vue&type=script&lang=js&"
export * from "./AddBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports